module.exports = __webpack_public_path__ + "media/images/angel_avatar-386443a217cb75a310fd7008a39436e8.png";